module.exports = __webpack_public_path__ + "static/media/banner.3da68a8c.jpg";